let baseDomain = 'https://us-central1-lyricster-pro.cloudfunctions.net';
// let stripeKey =
// 	'pk_test_51Jb9D0EoRUerKUzlBjuORItkDxAo9UJVvEdvR9bepQ0EYRKuTIxCncx0eaPVTe3naF6N1wMboyBYiJlRRI2GuYB400Ig8pbXmL';
let stripeKey = 'pk_live_51Jb9D0EoRUerKUzlgphmvC4dWk0aLRICFKTbBMeGvuOHIIVUByHPKTFJ1f6HzrgrJSrwjtIaboOGhiX91VuuxJDW00zOYfr2HL'
// let baseDomain = 'http://localhost:5001/lyricster-pro/us-central1';

export { baseDomain, stripeKey };
